module.exports = __webpack_public_path__ + "img/clubcard-loyalty-with-qr-code.17f61302.png";